<template>
  <Table.Base :auto-columns="false">
    <Table.Headers>
      <Table.Header class="pl-[18px]"> Dacr token </Table.Header>
      <Table.Header class="hidden tablet-h:block w-1/2!">
        Dacr Timestamp
      </Table.Header>
    </Table.Headers>
    <Table.Row @click="handleFileClick(token!)">
      <Table.Cell class="pl-[18px]">
        <ThumbnailIcon
          class="mr-2.5 min-w-9 max-w-9 h-9 tablet-h:min-w-6 tablet-h:max-w-6 tablet-h:h-6"
          :icon-size="iconSize"
          :type="props.token.type"
          :image-url="
            applyAuthorizationToken(token.imageUrl, [
              {
                key: 'width',
                value: 72,
              },
            ])
          "
        />
        <div v-truncate class="w-full">
          <div class="mb-0.5" data-truncate-target>
            {{ props.token.name }}
          </div>
          <div class="tablet-h:hidden flex items-center text-[13px] opacity-50">
            <Icon :size="14" name="Dacr" class="fill-gray-800 mr-1" />
            <div>
              {{ formatTimestamp(props.token.timestamp) }}
            </div>
          </div>
        </div>
      </Table.Cell>
      <Table.Cell class="w-1/2! hidden tablet-h:flex">
        <Icon :size="18" name="Dacr" class="fill-gray-800 mr-2" />
        <div>
          {{ formatTimestamp(props.token.timestamp) }}
        </div>
      </Table.Cell>
    </Table.Row>
  </Table.Base>
</template>

<script setup lang="ts">
import { ThumbnailIcon, Table } from '@dacr/ui'
import { type SearchFile } from '@/shared/graphql/legacy/generated'
import { useDevice } from '@/shared/composables/useDevice'
import { useRouter } from 'vue-router'
import { computed } from 'vue'
import { applyAuthorizationToken } from '@/shared/utils/url'
import { formatTimestamp } from '@/shared/utils/datetime'
import { Icon } from '@dacr/ui'

const props = defineProps<{
  token: SearchFile
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()

const device = useDevice()
const router = useRouter()

const iconSize = computed(() => (device.isMobile.value ? 36 : 24))

const handleFileClick = (file: SearchFile) => {
  router.push(`/file/${file.id}`)
  handleClose()
}

const handleClose = () => {
  emit('close')
}
</script>
